<div class="container-stepper-elements">
    <div class="container-state-and-bar" [ngStyle]="{'opacity': item.opacity ? 0.3 : 1}">
        <img src="{{item.state !== 0 ? 'https://panel.saldo.com.ar/img/states-public/' + item.state +'.png' : '../../../../../../../../assets/images/checked-state.png'}}"
            alt=" Estado de la transacción">
        <p class="state-title" matTooltipClass="tooltip-info">
            {{item.title}}
        </p>
    </div>
    <mat-progress-bar *ngIf="item.state !== 22" mode="determinate" value="{{item.progressBar}}"></mat-progress-bar>
</div>
